import { useQuery } from 'react-query'
import { getGlobalZones } from 'services/cm-api/get-global-zones'

export function useGetGlobalZones() {
  return useQuery(['getGlobalZones'], getGlobalZones, {
    enabled: Boolean(localStorage.getItem('FB_ACCESS_TOKEN')),
  })
}
